import React from "react";
import parse from "html-react-parser";
import Link from "../utils/link";
import {ArrowThickRight} from "./icons";
import Fade from "react-reveal/Fade";

const Reviews = ({title, subtitle, reviews, greenBackground}) => {
  return (
    <section className={`reviews ${greenBackground ? 'reviews--spacing' : ''}`}>
      <Fade bottom distance='40px'>
        <div className='reviews__inner'>
          {subtitle && <span className='reviews__subtitle'>{subtitle}</span>}

          <div className='reviews__title'>
            {title && <h2>{parse(title)}</h2>}
            <Link to='/reviews'>More Reviews <span className='arrow'><ArrowThickRight/></span></Link>
          </div>

          <div className='reviews__items'>
            {reviews?.length > 0 && reviews.map((el, i) => (
              <div key={i} className='reviews__item'>
                {el.content && parse(el.content)}
                {el.title && <h4>{el.title}</h4>}
              </div>
            ))}
          </div>
        </div>
      </Fade>
    </section>
  )
}

export default Reviews